import React, { useEffect } from "react";
import {
  ActivityRing,
  rings,
  SessionKeys,
  showTourAndGuideUtils,
} from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import HeaderFinwell from "../components/HeaderFinwell";
import SideMenuFinwell from "../components/SideMenuFinwell";
import Page from "./Page";
import { userDetailBroker } from "../../redux/user/actions";
import _ from "lodash";
import HomeBanner from "../components/home/HomeBanner";
import MoneyJourney from "../components/home/MoneyJourney";
import ActivityRingComp from "../components/home/ActivityRingComp";
import ContinueJourney from "../components/home/ContinueJourney";
import ForYou from "../components/home/ForYou";

const HomeFinwellPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.removeItem("i18nextLng");
    sessionStorage.removeItem("currentDuration");
    sessionStorage.removeItem("duration")
  }, []);

  return (
    <>
      <Page>
        <main id="main-content" tabIndex="-1">
          <HomeBanner />

          <MoneyJourney />

          <ActivityRingComp />

          <ContinueJourney />
          <div className="fro-you-home">
            <ForYou from = {"home"} selectedContentType={[]} />
          </div>
        </main>
      </Page>
    </>
  );
};

export default HomeFinwellPage;
